<template>
  <div class="flex flex-wrap gap-x-3 gap-y-1 md:gap-x-5 pl-5 md:pl-10 py-5 sticky bg-white -top-0 md:-top-6">
    <div
      v-for="legend in [['N/E', 'Non-évalué', ''], ['N/O', 'Non observable', 'bg-gray-600'], ['Non acquis', 'Non acquis', 'bg-pink-600'], ['En apprentissage', 'En apprentissage', 'bg-indigo-300'], ['En évolution', 'En évolution', 'bg-indigo-600'], ['Acquis', 'Acquis', 'bg-teal-600']]"
      :key="legend[0]"
      class="flex flex-row space-x-1 md:space-x-2 h-3 md:h-5 justify-start md:items-center"
    >
      <div
        class="h-3 w-3 md:h-5 md:w-5 rounded-full border border-gray-300 flex items-center justify-center"
        :class="legend[2]"
      >
        <span v-if="!legend[2]" class="text-gray-400 leading-none" style="font-size: 6px">N/E</span>
      </div>
      <div class="text-sm">
        {{ legend[1] }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CompetencesLegend'
};
</script>
